export var parseMessageData = function (data) {
    if (typeof data === 'string') {
        try {
            return JSON.parse(data);
        }
        catch (e) {
            return {};
        }
    }
    return data;
};
